// Travels with every batch and is stored on every event, so a query written
// later can tell which shape a row was written in.
//
// Bump on any change to events.ts or schemas.ts:
//   minor — new event, or a new optional property
//   major — removed event, renamed or removed property, changed type
const CONTRACT_VERSION = '0.1.0';

export { CONTRACT_VERSION };
